(function () {
    var s = (typeof (Vendd) !== "undefined" && Vendd.Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';

        if (!window.CitrusAd) {
            return;
        }

        var trackingScriptName = 'ProjectAgora';
        var trackingModel = LhApp.Function.Tracking.getTrackingModel();
        var tracker = LhApp.Function.Tracking.getTracker("projectagora", trackingModel);
        
        if (!tracker || !tracker.Properties || !tracker.Properties.ModuleConfiguration) {
            return;
        }

        var cookieType = tracker.CookieGroupCode ? tracker.CookieGroupCode : '';
        var Cantrack = LhApp.Function.Tracking.canTrack(cookieType);

        InitAll();
        function InitAll() {
            if (!Cantrack) return;

            var projectAgoraBaseUrl = tracker.Properties.ModuleConfiguration.BaseUrl + '/v1';

            var trackableSelector = '[data-project-agora-id]';
            var trackingClassName = 'pa-tracking';
            var displayedClassName = 'pa-displayed';

            var trackingElements = [];
            var displayedTrackingIds = [];
            var clickedTrackingIds = [];
            var reportedDisplayedTrackingIds = [];
            var reportedClickedTrackingIds = [];

            function init(config) {
                window.citrusAd = window.citrusAd || CitrusAd.init(config.baseUrl, {
                    disableTracking: false,
                    trackingOptions: {
                        sessionId: config.sessionId
                    }
                });

                processQueuedImpressions();
                processQueuedClicks();
            }

            function processQueuedImpressions() {
                if (window.citrusAd) {
                    $.each(displayedTrackingIds, function (index, trackingId) {
                        if (!reportedDisplayedTrackingIds.includes(trackingId)) {
                            reportedDisplayedTrackingIds.push(trackingId);
                            window.citrusAd.reportImpression(trackingId);
                        }
                    });
                    displayedTrackingIds = [];
                }
            }

            function processQueuedClicks() {
                if (window.citrusAd) {
                    $.each(clickedTrackingIds, function (index, trackingId) {
                        if (!reportedClickedTrackingIds.includes(trackingId)) {
                            reportedClickedTrackingIds.push(trackingId);
                            window.citrusAd.reportClick(trackingId);
                        }
                    });
                    clickedTrackingIds = [];
                }
            }

            function processClick(trackingId, targetUrl) {
                if (window.citrusAd) {
                    window.citrusAd.reportClick(trackingId).then(function () {
                        window.top.location.href = targetUrl;
                    });
                    return true;
                }
                return false;
            }

            function updateTrackingElements() {
                $(trackableSelector).each(function () {
                    var $this = $(this);

                    if (!$this.hasClass(trackingClassName)) {
                        $this.addClass(trackingClassName);
                        trackingElements.push(this);
                    }
                });
            }

            function updateDisplayedElements() {
                $.each(trackingElements, function () {
                    var $this = $(this);

                    if (!$this.hasClass(displayedClassName) && isVisible(this)) {
                        var trackingId = $this.data('project-agora-id');
                        $this.addClass(displayedClassName);

                        if (!displayedTrackingIds.includes(trackingId)) {
                            displayedTrackingIds.push(trackingId);
                        }
                    }
                });
            }

            function isVisible(element) {
                var rect = element.getBoundingClientRect();
                return 0 <= rect.top && rect.bottom <= window.innerHeight;
            }


            $(document).on('click', 'a[data-project-agora-id]', function (e) {
                var $this = $(this);
                var trackingId = $this.data('project-agora-id');
                var targetUrl = $this.attr('href');

                if (processClick(trackingId, targetUrl)) {
                    e.preventDefault();
                }
            });

            $(document).on('scroll', $.debounce(300, function () {
                updateDisplayedElements();
                processQueuedImpressions();
            }));

            Vendd.MessageBus.subscribe(Vendd.ProjectAgora.Messages.TrackBannerImpression, trackingScriptName, function (envelope) {
                updateTrackingElements();
                updateDisplayedElements();
                processQueuedImpressions();
            });

            Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, trackingScriptName, function (envelope) {
                updateTrackingElements();
                updateDisplayedElements();
                processQueuedImpressions();
            });

            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, trackingScriptName, function (envelope) {
                $(envelope.sender).closest('[data-project-agora-id]').each(function () {
                    var $this = $(this);
                    var trackingId = $this.data('project-agora-id');
                    $this.addClass(displayedClassName);

                    if (!clickedTrackingIds.includes(trackingId)) {
                        clickedTrackingIds.push(trackingId);
                    }
                });

                processQueuedClicks();
            });

            Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, trackingScriptName, function (envelope) {
                var sessionState = envelope.message.data;
                var sessionId = sessionState.SessionId;
                var config = {
                    baseUrl: projectAgoraBaseUrl,
                    sessionId: sessionId
                };
                init(config);
            });

            updateTrackingElements();
            updateDisplayedElements();
        }

        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            //On consents update, re-initialize this tracker
            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, TrackingScriptName, function () {
                Cantrack = LhApp.Function.Tracking.canTrack(cookieType);
                InitAll();
            });
        }
    });
})();
